export class SearchHelpers {
  public static tokenizeString(str, tokenizers = "\\s") {
    if (!str) return [];
    const regex = new RegExp(`(?:[^${tokenizers}"]+|"[^"]*")+`, "g");
    return str.match(regex);
  }

  public static stripQuotes(str) {
    if (!str || !str.trim()) return "";
    const result = str.match(/^"(.*)"$/);
    if (result && result.length > 1) return result[1];
    return str;
  }

  public static cleanParam(param = "") {
    const clean = ((typeof param) !== "string") ? `${param}` : param;
    return clean.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
  }

  public static makeRegExp(param = "", flags = "i"): RegExp {
    return new RegExp(SearchHelpers.cleanParam(param), flags);
  }
}
